/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Leonid Khramov
 */
import React, { Component } from 'react'
import { ModalPage } from '../../../modules/Navigation'

export default class ContainerWithMenu extends Component {

    constructor(props, mainCSSClass, selectedMenuId) {
        super(props)

        this.mainCSSClass = mainCSSClass
        this.selectedMenuId = selectedMenuId
        this.onClose = this.onClose.bind(this)
        this.onBack = this.onBack.bind(this)
        this.state = {
            isMenuOpened: false
        }
    }

    superTitle() {
        var title = this.getTitle()
        if (this.props.title) {
            title = this.props.title
        }
        return title
    }

    getTitle() {
        return null
    }

    getMainCSSClass() {
        return this.mainCSSClass
    }

    renderContent() {
        return null
    }
    
    isFromIOS() {
        return undefined
    }
    
    hideBack() {
        return false
    }

    hideClose() {
        return false
    }

    onClose() {
        if (this.isFromIOS()) {
            window.location = 'traceteams://return/from/admin'
        } else {
            this.props.history.replace(`/${this.props.match.params.team}`)
        }
    }

    onBack() {
        this.props.history.go(-1)
    }

    render() {
        return (
            <ModalPage 
                title={this.superTitle()} 
                showBack={this.hideBack()}
                showClose={this.hideClose()}
                onBackPressed={this.onBack}
                onClosePressed={this.onClose}
                hideHeader={this.isFromIOS()}>

                {this.renderContent()}

            </ModalPage>
        )
    }

    isDivisionOwner(divisionId) {
        const id = '' + divisionId
        const divisions = this.props.divisions
        if(!divisions) return false
        const curDivision = divisions.find((item) => '' + item.division_id === id)
        return curDivision && (curDivision.is_owner === '1' || curDivision.is_owner === true)
    }
}
